import { Outlet } from "react-router-dom";
import OnboardingMarketplaceHeader from "../components/OnboardingMarketplaceHeader";

export const OnboardingLayout = () => {
  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <OnboardingMarketplaceHeader />
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
};
